import { combineI18nMessages, defaultMessagesBG, HTML_CODES } from "@duosoftbg/nacid-components";
import validationKeysBG from "./slices/validationKey/validationKeysBG";

const messagesBg = combineI18nMessages(defaultMessagesBG, {
  translation: {
    "t.page.homePage": "Начало",
    "t.page.sitemap": "Карта на сайта",
    "t.page.sitemap.edit": "Редактиране карта на сайта",
    "t.page.homePageCategory.edit": "Съдържание на начална страница - редакция",
    "t.page.contacts.edit": "Редактиране на контакти",
    "t.page.serviceDefinitions.edit": "Редактиране на описания на услуги",
    "t.page.feedback.admin": "Администриране на обратна връзка",
    "t.page.global.message.admin": "Администриране на глобални съобщения",
    "t.page.email.templates.admin": "Администриране на имейл темплейти",
    "t.page.email.notifications.admin": "Администриране на имейл нотификации",
    "t.page.admin.console": "Административен модул",
    "t.page.contacts": "Контакти",
    "t.page.law": "Законодателство",
    "t.page.law.edit": "Редактиране на законодателство",
    "t.page.cache": "Изчистване на кеша",
    "t.page.registration": "Създаване на потребителски профил",
    "t.page.registration.success": "Успешно създаване на потребителски профил",
    "t.page.feedback": "Мнения, предложения, препоръки и срещнати проблеми",
    "t.page.my.account": "Моят профил",
    "t.page.forgotten.password": "Забравена парола",
    "t.page.forgotten.username": "Забравено потребителско име",
    "t.page.activation.link": "Нов линк за активация на профил",
    "t.page.reset.password": "Възстановяване на парола",
    "t.page.account.activation": "Активиране на потребителски профил",
    "t.page.change.email": "Промяна на имейл адрес",
    "t.page.admin.console.config": "Конфигурация на административен модул",
    "t.homePageCategory.create.dialog": "Създаване на категория",
    "t.homePageCategory.edit.dialog": "Радактиране на категория",
    "t.homePageCategoryLink.create.dialog": "Създаване на линк",
    "t.homePageCategoryLink.edit.dialog": "Радактиране на линк",
    "t.sitemap.group.create.dialog": "Създаване на група",
    "t.sitemap.group.delete.dialog": "Изтриване на група",
    "t.homePage.category.delete.dialog": "Изтриване на категория",
    "t.homePage.category.link.delete.dialog": "Изтриване на линк",
    "t.sitemap.subgroup.delete.dialog": "Изтриване на подгрупа",
    "t.law.file.delete.dialog": "Изтриване на файл",
    "t.sitemap.link.delete.dialog": "Изтриване на линк",
    "t.sitemap.group.edit.dialog": "Редактиране на група",
    "t.sitemap.subgroup.create.dialog": "Създаване на подгрупа",
    "t.sitemap.subgroup.edit.dialog": "Редактиране на подгрупа",
    "t.sitemap.link.create.dialog": "Създаване на линк",
    "t.sitemap.link.edit.dialog": "Редактиране на линк",
    "t.email.notification.delete.dialog": "Изтриване на нотификация",
    "t.email.notification.resend.dialog": "Повторно изпращане на нотификация",
    "t.email.notification.view.dialog": "Преглед на нотификация",
    "t.email.template.delete.dialog": "Изтриване на темплейт",
    "t.email.globalMessage.delete.dialog": "Изтриване на съобщение",
    "t.email.serviceDefinition.delete.dialog": "Изтриване на описание",
    "t.email.globalMessage.activation.dialog": "Активация/деактивация на съобщение",
    "t.email.template.create.dialog": "Създаване на темплейт",
    "t.globalMessage.create.dialog": "Създаване на съобщение",
    "t.globalMessage.edit.dialog": "Редактиране на съобщение",
    "t.email.template.edit.dialog": "Промяна на темплейт",
    "t.email.template.view.dialog": "Преглед на темплейт",
    "t.global.message.view.dialog": "Преглед на съобщение",
    "t.service.definition.view.dialog": "Преглед на описание",
    "t.service.definition.edit.dialog": "Редактиране на описание",
    "t.service.definition.create.dialog": "Създаване на описание",
    "t.feedback.details.dialog": "Подробности за обратната връзка",
    "t.feedback.text": "Обратна връзка",
    "t.homePage.services": "Електронни услуги",
    "t.homePage.reports": "Справки",
    "t.homePage.law": "Законодателство",
    "t.homePage.registers": "Достъп до публични регистри",
    "t.homePage.userGuide": "Ръководсвто за потребителя",
    "t.page.groupsAndRoles.admin": "Администриране на групи и роли",
    "t.tab.groups": "Групи",
    "t.tab.roles": "Роли",
    "t.role.view.dialog": "Преглед на роля",
    "t.role.edit.dialog": "Редакция на роля",
    "t.main.details": "Основни данни",
    "t.logo": "Лого",
    "t.special.actions": "Специални действия",
    "t.change.email.dialog": "Промяна на имейл адрес",
    "t.change.password.dialog": "Промяна на парола",
    "t.role.users": "Потребители с тази роля",
    "t.role.groupUsers": "Потребители с тази роля поради членство в група",
    "t.group.create.dialog": "Създаване на група",
    "t.group.edit.dialog": "Редакция на група",
    "t.group.view.dialog": "Преглед на група",
    "t.group.roles": "Роли на групата",
    "t.group.users": "Потребители в групата",
    "t.page.users.admin": "Администриране на потребители",
    "t.page.user.admin.edit": "Редакция на потребител",
    "t.page.user.admin.view": "Преглед на потребител",
    "t.user.roles": "Роли на потребителя",
    "t.user.groups": "Групи на потребителя",
    "t.user.view.dialog": "Преглед на потребител",
    "t.ac.roles": "Роли",
    "t.ac.section.create.dialog": "Създаване на секция",
    "t.ac.section.update.dialog": "Редактиране на секция",
    "t.ac.section.delete.dialog": "Изтриване на секция",
    "t.ac.page.create.dialog": "Създаване на страница",
    "t.ac.page.update.dialog": "Редактиране на страница",
    "t.ac.page.delete.dialog": "Изтриване на страница",
    "t.personal.details": "Лични данни",
    "t.registration.details": "Регистрационни данни",
    "t.account.verification.details": "Верификация на профил",
    "t.representative.details": "Представител",
    "t.contactAddress.details.default": "Адрес за контакт по подразбиране",
    "t.resultReceive.way.default": "Начин за получаване на резултат по подразбиране",
    "t.resultReceive.way": "Начин за получаване на резултат",
    "t.receiverAddress.details.default": "Адрес на получател по подразбиране",
    "t.educationSystemsOverview": "Преглед на образователните системи",
    "t.qualAssess": "Сравняване на степените на висше образование",

    "l.detail.info": "Информация",
    "l.detail.regulations": "Нормативни документи",
    "l.detail.address": "Адрес",
    "l.detail.infoCenter": "Инфо-център",
    "l.detail.telephone": "Телефон",
    "l.detail.fax": "Факс",
    "l.detail.email": "Ел.поща",
    "l.detail.website": "Уебсайт",
    "l.table.head.logo": "Лого",
    "l.table.head.file": "Файл",
    "l.table.head.id": "Идентификатор",
    "l.table.head.service": "Услуга",
    "l.table.head.section": "Име на секция",
    "l.table.head.section.en": "Име на секция на английски",
    "l.table.head.subGroupName": "Име на подгрупа",
    "l.table.head.groupName": "Име на група",
    "l.table.head.groupNameEn": "Име на група на английски",
    "l.table.head.position": "Позиция",
    "l.table.head.pages": "Страници",
    "l.table.head.page": "Име на страница",
    "l.table.head.page.en": "Име на страница на английски",
    "l.table.head.children": "Вложена страница",
    "l.table.head.children.en": "Вложена страница на английски",
    "l.table.head.subGroupNameEn": "Име на подгрупа на английски",
    "l.table.head.subGroups": "Подгрупи",
    "l.table.head.groups": "Групи",
    "l.table.head.sentDate": "Дата на изпращане",
    "l.table.head.subject": "Тема",
    "l.table.head.recipients": "Получатели",
    "l.table.head.status": "Статус",
    "l.table.head.name": "Име",
    "l.table.head.settlementName": "Населено място",
    "l.table.head.address": "Адрес",
    "l.table.head.zipcode": "Пощенски код",
    "l.table.head.website": "Сайт",
    "l.table.head.nameEn": "Име (EN)",
    "l.table.head.lastUpdateDate": "Последна промяна",
    "l.btn.home": "Начало",
    "l.btn.create.group": "Създай група",
    "l.btn.edit.group": "Редактирай група",
    "l.btn.create.subgroup": "Създай подгрупа",
    "l.btn.edit.subgroup": "Редактирай подгрупа",
    "l.btn.edit.contacts": "Редактирай контакти",
    "l.btn.create.link": "Създай линк",
    "l.btn.edit.link": "Редактирай линк",
    "l.btn.register": "Създай профил",
    "l.btn.forgotten.password": "Възстановяване на паролата",
    "l.btn.submit": "Изпрати",
    "l.btn.view.all": "Виж всички",
    "l.btn.attachment.save": "Изтегляне на прикачения файл",
    "l.btn.feedback.mark.read": "Маркирай съобщението като прочетено",
    "l.btn.change.email": "Промяна на имейл адрес",
    "l.btn.change.password": "Промяна на парола",
    "l.btn.delete.read": "Премахване на прочетените",
    "l.btn.create.template": "Създай темплейт",
    "l.btn.create.globalMessage": "Създай съобщение",
    "l.btn.create.serviceDefinition": "Създай описание на услуга",
    "l.btn.save.template": "Запази темплейт",
    "l.user.username": "Потребителско име",
    "l.user.password": "Парола",
    "l.user.confirmPassword": "Въведете отново",
    "l.table.head.links": "Линкове",
    "l.table.head.link": "Линк",
    "l.table.head.linkName": "Име на линк",
    "l.table.head.linkNameEn": "Име линк на английски",
    "l.table.head.person.name": "Име",
    "l.table.head.createdDate": "Дата на създаване",
    "l.table.head.updatedDate": "Дата на последна промяна",
    "l.table.head.type": "Тип",
    "l.table.head.isRead": "Прочетено",
    "l.input.sitemap.id": "Идентификатор",
    "l.input.sitemap.group.name": "Име на група",
    "l.input.sitemap.group.nameEn": "Име на група на английски",
    "l.input.sitemap.position": "Позиция",
    "l.input.sitemap.subgroup.name": "Име на подгрупа",
    "l.input.sitemap.subgroup.nameEn": "Име на подгрупа на английски",
    "l.input.ac.id": "Идентификатор",
    "l.input.ac.section.title": "Име на секция",
    "l.input.ac.section.title.en": "Име на секция на английски",
    "l.input.ac.page.title": "Име на страница",
    "l.input.ac.page.title.en": "Име на страница на английски",
    "l.input.ac.position": "Позиция",
    "l.input.home.category.position": "Позиция",
    "l.input.ac.href": "Линк",
    "l.person.name": "Име",
    "l.person.foreignerIdentifierKind": "Вид идентификатор",
    "l.person.isRepresentative": "Регистрираният потребител в портала е представител на фирма или висше училище",
    "l.person.representative.type": "Тип представител",
    "l.person.representative.type.UNIVERSITY_REPRESENTATIVE": "Представител на висше училище",
    "l.person.representative.type.COMPANY_REPRESENTATIVE": "Представител на фирма",
    "l.university": "Университет",
    "l.company": "Фирма",
    "l.eik": "ЕИК",
    "l.detail.zipCode": "Пощенски код",
    "l.detail.city": "Град",
    "l.feedback": "Обратна връзка",
    "l.input.sitemap.link.name": "Име на линк",
    "l.input.sitemap.link.nameEn": "Име на линк на английски",
    "l.input.sitemap.link": "Линк",
    "l.input.category.link": "Линк",
    "l.searchFilter.recipients": "Получатели",
    "l.searchFilter.status": "Статус",
    "l.searchFilter.statusCode": "Статус",
    "l.searchFilter.globalMessageType": "Тип",
    "l.searchFilter.createdDate": "Дата на създаване",
    "l.searchFilter.sentDate": "Дата на изпращане",
    "l.searchFilter.nameEn": "Име (EN)",
    "l.searchFilter.subject": "Тема",
    "l.searchFilter.text": "Съдържание",
    "l.searchFilter.textEn": "Съдържание (EN)",
    "l.searchFilter.lastUpdateDate": "Дата на последна промяна",
    "l.searchFilter.isHtml": "HTML",
    "l.email.notification.sent": "Изпратен",
    "l.email.notification.notSent": "Неизпратен",
    "l.email.notification.inSendingProcess": "В процес на изпращане",
    "l.email.notification.resent": "Повторно изпратен",
    "l.email.notification.id": "Идентификатор",
    "l.email.notification.subject": "Тема",
    "l.email.notification.recipients": "Получатели",
    "l.email.notification.cc": "CC",
    "l.email.notification.bcc": "BCC",
    "l.email.notification.createdDate": "Дата на създаване",
    "l.email.notification.sentDate": "Дата на изпращане",
    "l.email.notification.isHtml": "HTML",
    "l.email.notification.replyTo": "В отговор на",
    "l.email.notification.comment": "Коментар",
    "l.email.notification.skipSending": "Пропускане на изпращане",
    "l.email.notification.text": "Съдържание",
    "l.email.template.id": "Идентификатор",
    "l.email.template.name": "Име",
    "l.globalMessage.name": "Име",
    "l.email.template.nameEn": "Име (EN)",
    "l.globalMessage.nameEn": "Име (EN)",
    "l.globalMessage.text": "Текст",
    "l.serviceDefinition.id": "Услуга",
    "l.serviceDefinition.description": "Описание",
    "l.globalMessage.textEn": "Текст (EN)",
    "l.email.template.subject": "Заглавие на имейлите, които използват този темплейт",
    "l.email.template.text": "Съдържание",
    "l.email.template.createdDate": "Дата на създаване",
    "l.globalMessage.createdDate": "Дата на създаване",
    "l.globalMessage.lastUpdateDate": "Дата на последна промяна",
    "l.globalMessage.type": "Тип",
    "l.globalMessage.active": "Активен",
    "l.email.template.lastUpdateDate": "Дата на последна промяна",
    "l.email.template.isHtml": "HTML",
    "l.email.template.userCreate": "Създател",
    "l.email.template.userLastUpdate": "Последна промяна от",
    "l.email.template.params": "Параметри",
    "l.select.user": "Избери потребител",
    "l.select.role": "Избери роля",
    "l.settlement": "Населено място",
    "l.description": "Описание",
    "l.description.en": "Описание на английски",
    "l.name": "Име",
    "l.reports.logo": "Лого доклади",
    "l.libserv.logo": "Лого библиотечни услуги",
    "l.apostille.logo": "Лого печат",
    "l.certificates.logo": "Лого сертификати",
    "l.academic.recognition.logo": "Лого академично признание",
    "l.registers.logo": "Лого регистри",
    "l.common.services.logo": "Лого общи услуги",
    "l.impact.factor.logo": "Лого импакт фактор",
    "l.prof.qualification.logo": "Лого професионални квалификации",
    "l.logo": "Лого",
    "l.table.head.description": "Описание",
    "l.table.head.descriptionEn": "Описание(EN)",
    "l.searchFilter.description": "Описание",
    "l.searchFilter.username": "Потребителско име",
    "l.searchFilter.email": "Имейл",
    "l.searchFilter.enabled": "Активен",
    "l.searchFilter.emailVerified": "Потвърден имейл",
    "l.table.head.username": "Потребителско име",
    "l.table.head.email": "Имейл",
    "l.table.head.enabled": "Активен",
    "l.table.head.emailVerified": "Потвърден имейл",
    "l.user.enabled": "Активен",
    "l.user.emailVerified": "Потвърден имейл",
    "l.user.email": "Имейл",
    "l.select.group": "Избери група",
    "l.arUniEntryRequest": "Подаване на данни по чл.19, ал.2",
    "l.arUniEntryRequest.list": "Моите данни по чл.19, ал.2",
    "l.showInServicesPage": "Покажи и на страница Всички услуги",
    "l.btn.expandDetails": "Покажи детайли",
    "l.countryName": "Име на държава",
    "l.eqfStatus": "ЕКР статус",
    "l.eqfStatus.full": "Напълно съвместима с ЕКР",
    "l.eqfStatus.partial": "Частично съвместима с ЕКР",
    "l.eqfStatus.none": "Не е съвместима с ЕКР",
    "l.region": "Регион",
    "l.systemType": "Вид система",

    "validation.definition.already.exist": "Вече съществува описание за тази услуга",
    "validation.field.positive.number": "Въведете положително число",
    "validation.field.email.bad.format": "Невалиден имейл адрес",
    "validation.confirmPassword.incorrect": "Паролите не съвпадат",
    "validation.username.charCount.invalid": "Невалидно потребителско име. Максимална дължина: 100",
    "validation.title.ac.charCount.invalid": "Невалидно име. Максимална дължина: 100",
    "validation.city.charCount.invalid": "Невалидно населено място. Максимална дължина: 200",
    "validation.postCode.charCount.invalid": "Невалиден пощенски код. Максимална дължина: 50",
    "validation.address.charCount.invalid": "Невалиден адрес. Максимална дължина: 500",
    "validation.phone.charCount.invalid": "Невалиден телефон. Максимална дължина: 20",
    "validation.fax.charCount.invalid": "Невалиден факс. Максимална дължина: 50",
    "validation.postBox.charCount.invalid": "Невалидна пощенска кутия. Максимална дължина: 100",
    "validation.name.charCount.invalid": "Невалидно име. Максимална дължина: 200",
    "validation.number.positive.number": "Въведете положително число",
    "validation.feedback.charCount.invalid": "Невалидна обратна връзка. Максимална дължина: 2000",
    "validation.attachment.file.required": "Трябва да изберете файл",
    "validation.username.alreadyExists.invalid": "Потребителското име вече съществува",
    "validation.username.invalid": `Невалидно потребителско име. ${HTML_CODES.BREAK_LINE} - позволен брой символи от 5 до 30 ${HTML_CODES.BREAK_LINE} - главни букви не са позволени ${HTML_CODES.BREAK_LINE} - може да съдържа латински букви, цифри и специалните символи '.', '-' и '_' ${HTML_CODES.BREAK_LINE} - не може да започва с '.', '-' и '_' ${HTML_CODES.BREAK_LINE} - не може да съдържа поредица от последователни специални символи`,
    "validation.email.charCount.invalid": "Невалиден имейл. Максимална дължина: 100",
    "validation.birthPlace.charCount.invalid": "Невалидно населено място на раждане. Максимална дължина: 200",
    "validation.documentId.charCount.invalid": "Невалиден номер на идентификатор. Максимална дължина: 100",
    "validation.email.alreadyExists.invalid": "Имейлът вече съществува",
    "validation.password.invalid": `Невалидна парола. ${HTML_CODES.BREAK_LINE} - минимална дължина 8 символа ${HTML_CODES.BREAK_LINE} - поне една малка буква ${HTML_CODES.BREAK_LINE} - поне една голяма буква ${HTML_CODES.BREAK_LINE} - поне една цифра`,
    "validation.file.type": `Неразрешен тип на файла. ${HTML_CODES.BREAK_LINE} Позволени типове: PDF и JPEG`,
    "validation.createdDate.invalid": "Въведете валиден период за филтриране по дата на създаване",
    "validation.sentDate.invalid": "Въведете валиден период за филтриране по дата на изпращане",
    "validation.email.non.existing": "Не съществува потребител с посочения имейл",
    "validation.lastUpdateDate.invalid": "Въведете валиден период за филтриране по дата на последна промяна",

    "m.home.introduction.subtitle":
      "Този портал предоставя достъп до всички електронни административни услуги на Националния център за информация и документация с възможност за преглед на документи и справки.",
    "m.homePage.services":
      "Списък на административните услуги на НАЦИД, които можете да заявите онлайн. За да имате достъп до всички услуги е необходимо да влезнете в своя потребителски профил.",
    "m.homePage.reports":
      "Възможност да проследите текущото състояние на Вашите преписки. За да намерите преписка, трябва да разполагате с номера й и кода за достъп",
    "m.homePage.law": "Документи, свързани с комплексно административно обслужване в НАЦИД.",
    "m.homePage.registers": "Списък с публични регистри на Национален център за информация и документация",
    "m.homePage.registers.academicRecognition": "- aкадемично признаване",
    "m.homePage.registers.professionalQualifications": "- професионални квалификации",
    "m.delete.sitemap.group.warning.message": "Сигурни ли сте, че искате да изтриете тази група?",
    "m.delete.homePage.category.warning.message": "Сигурни ли сте, че искате да изтриете тази категория?",
    "m.delete.homePage.category.link.warning.message": "Сигурни ли сте, че искате да изтриете този линк?",
    "m.delete.sitemap.subgroup.warning.message": "Сигурни ли сте, че искате да изтриете тази подгрупа?",
    "m.delete.ac.section.warning.message": "Сигурни ли сте, че искате да изтриете тази секция?",
    "m.delete.ac.page.warning.message": "Сигурни ли сте, че искате да изтриете тази страница?",
    "m.delete.law.file.warning.message": "Сигурни ли сте, че искате да изтриете този файл?",
    "m.delete.sitemap.link.warning.message": "Сигурни ли сте, че искате да изтриете този линк?",
    "m.delete.email.notification.warning.message": "Сигурни ли сте, че искате да изтриете тази нотификация?",
    "m.resend.email.notification.warning.message": "Сигурни ли сте, че искате да изпратите повторно тази нотификация?",
    "m.delete.email.template.warning.message": "Сигурни ли сте, че искате да изтриете този темплейт?",
    "m.delete.email.globalMessage.warning.message": "Сигурни ли сте, че искате да изтриете това съобщение?",
    "m.delete.service.definition.warning.message": "Сигурни ли сте, че искате да изтриете това описание?",
    "m.activation.email.globalMessage.warning.message":
      "Сигурни ли сте, че искате да активирате/деактивирате това съобщение?",
    "m.create.template.success": "Успешно запазен темплейт",
    "m.create.globalMessage.success": "Успешно запазено глобално съобщение",
    "m.update.serviceDefinition.success": "Успешно редактирано описание",
    "m.create.serviceDefinition.success": "Успешно създаване на описание",
    "m.feedback.submit.success": "Успешно изпратена обратна връзка",
    "m.file.hint": `Позволени типове: PDF и JPEG. ${HTML_CODES.BREAK_LINE} Максимален размер на файла: 10MB.`,
    "m.file.pdf.allowed.type.message": `Позволени типове: PDF. ${HTML_CODES.BREAK_LINE} Максимален размер на файла: 10MB.`,
    "m.file.img.allowed.type.message": `Позволени типове: IMG. ${HTML_CODES.BREAK_LINE} Максимален размер на файла: 10MB.`,
    "m.alert.pleaseEnterValidSearchCriteria": "Моля въведете валидни критерии за търсене",
    "m.feedback.mark.read.success": "Съобщението е маркирано като прочетено!",
    "m.feedback.delete.read.success": "Прочетените съобщения са премахнати!",
    "m.forgotten.password.email.success": "Успешно е изпратен имейл за промяна на паролата!",
    "m.forgotten.username.email.success": "Потребителското Ви име е изпратено на посочения от Вас имейл!",
    "m.activation.link.email.success": "Успешно е изпратен имейл за активация!",
    "m.reset.password.key.invalid": "Невалиден ключ за смяна на парола!",
    "m.reset.password.user.invalid": "Не е намерен потребител, за когото се отнася ключът за смяна на парола!",
    "m.reset.password.key.expired":
      "Времето за смяна на парола е изтекло, моля опитайте отново чрез страница 'Забравена парола'!",
    "m.reset.password.key.used": "Ключът за смяна на парола вече е използван!",
    "m.reset.password.key.error": "Възникна грешка при проверка на ключа за смяна на парола!",
    "m.reset.password.success": "Паролата на потребител {{user}} е сменена успешно!",
    "m.registration.success":
      "Успешно създаден потребителски профил: <b>{{username}}</b>. Имейл за активация на профила е изпратен на: <b>{{email}}</b>.",
    "m.account.activation.key.invalid":
      "Невалиден ключ за активация! Моля направете заявка за нов активационен ключ или изпратете запитване до Администратор.",
    "m.account.activation.user.invalid":
      "Не е намерен потребител, за когото се отнася ключът за активация! Моля направете заявка за нов активационен ключ или изпратете запитване до Администратор.",
    "m.account.activation.already.activated": "Потребителският профил {{user}} вече е бил активиран!",
    "m.account.activation.key.expired":
      "Времето за активация е изтекло! Моля направете заявка за нов активационен ключ или изпратете запитване до Администратор.",
    "m.account.activation.key.error":
      "Възникна грешка в процеса на активация. Моля направете заявка за нов активационен ключ или изпратете запитване до Администратор.",
    "m.account.activation.success": "Потребителският профил {{user}} е успешно активиран!",
    "m.change.email.key.invalid":
      "Невалиден ключ за смяна на имейл! Моля направете повторна заявка за смяна на имейл чрез страница 'Моят профил'.",
    "m.change.email.new.email.invalid":
      "Подаден е невалиден имейл в заявката за смяна на имейл адрес ! Моля направете повторна заявка за смяна на имейл чрез страница 'Моят профил'.",
    "m.change.email.used.key": "Ключът за смяна на имейл вече е използван!",
    "m.change.email.new.email.not.found":
      "Не е намерен имейл в заявката за смяна на имейл адрес ! Моля направете повторна заявка за смяна на имейл чрез страница 'Моят профил'.",
    "m.change.email.user.invalid":
      "Не е намерен потребител, за когото се отнася ключът за смяна на имейл! Моля направете повторна заявка за смяна на имейл чрез страница 'Моят профил'.",
    "m.change.email.key.expired":
      "Времето за промяна на имейл адресът е изтекло! Моля направете повторна заявка за смяна на имейл чрез страница 'Моят профил'.",
    "m.change.email.success": "Имейл адресът е сменен успешно! Нов имейл: {{newEmail}}",
    "m.change.email.error":
      "Възникна грешка в процеса по смяна на имейл адреса. Моля направете повторна заявка за смяна на имейл чрез страница 'Моят профил'.",
    "m.role.user.remove.confirm": "Сигурни ли сте, че искате да премахнете този потребител от ролята?",
    "m.confirm": "Моля, потвърдете",
    "m.role.user.remove.success": "Потребителят беше премахнат успешно",
    "m.role.user.add.success": "Потребителят беше добавен успешно",
    "m.group.create.success": "Групата беше създадена успешно",
    "m.group.update.success": "Основните данни на групата бяха променени успешно",
    "m.group.delete.confirm": "Сигурни ли сте, че желаете да изтриете тази група?",
    "m.group.delete.success": "Групата беше изтрита успешно",
    "m.group.user.remove.success": "Потребителят беше премахнат успешно",
    "m.group.role.remove.success": "Ролята беше премахната успешно",
    "m.group.user.add.success": "Потребителят беше добавен успешно",
    "m.group.role.add.success": "Ролята беше добавена успешно",
    "m.group.user.remove.confirm": "Сигурни ли сте, че желаете да премахнете потребителя от групата?",
    "m.group.role.remove.confirm": "Сигурни ли сте, че желаете да премахнете ролята от групата?",
    "m.user.main.data.update.success": "Основните данни на потребителя бяха променени успешно !",
    "m.user.group.remove.confirm": "Сигурни ли сте, че желаете да премахнете групата от потребителя?",
    "m.user.role.remove.confirm": "Сигурни ли сте, че желаете да премахнете ролята от потребителя?",
    "m.user.group.remove.success": "Групата беше премахната успешно",
    "m.user.role.remove.success": "Ролята беше премахната успешно",
    "m.user.group.add.success": "Групата беше добавена успешно",
    "m.user.role.add.success": "Ролята беше добавена успешно",
    "m.user.send.change.email.success": "Имейлът за потвърждение на новия имейл адрес беше изпратен успешно",
    "m.user.change.password.success": "Паролата беше променена успешно",
    "m.ac.section.create.success": "Секцията беше добавена успешно",
    "m.ac.section.update.success": "Секцията беше редактирана успешно",
    "m.ac.page.create.success": "Страницата беше добавена успешно",
    "m.ac.page.update.success": "Страницата беше редактирана успешно",
    "t.page.nomenclatures.reference.data": "Обединени номенклатури",
    "t.page.nomenclatures.national.university": "Национални университети",
    "t.page.nomenclatures.getting.result.method": "Начин на получаване на резултат",
    "l.reference.data.domain": "Домейн",
    "l.searchFilter.domain": "Домейн",
    "l.table.head.domain": "Домейн",
    "m.serviceDefinition.higherEducationRecognition": "Признаване на ОКС бакалавър и магистър, придобити в чужбина",
    "m.serviceDefinition.doctorateDegrees.doctor": "Признаване на ОНС Доктор, придобита в чужбина",
    "m.serviceDefinition.doctorateDegrees.doctorOfScience": "Признаване на НС Доктор на науките, придобит в чужбина",
    "m.serviceDefinition.uniChecks.academicStatus": "Проверка на академичния статут на чуждестранни висши училища",
    "m.serviceDefinition.uniChecks.documentAuthenticity":
      "Проверка на автентичността на документи за висше образование от чуждестранни висши училища",
    "m.serviceDefinition.uniChecks.issueRecommendation":
      "Издаване на препоръка за признаване на придобито висше образование в чуждестранни висши училища",
    "m.serviceDefinition.nonRegulatedProfessions":
      "Издаване на удостоверение за професионална квалификация по нерегулирана в България професия за други страни",
    "m.serviceDefinition.publicAccess": "Предоставяне на достъп до обществена информация",
    "m.serviceDefinition.suggestion": "Подаване на предложение",
    "m.serviceDefinition.signal": "Подаване на сигнал",
    "m.serviceDefinition.officialNotes.researchProject":
      "Издаване на служебни бележки за завършени научноизследователски проекти",
    "m.serviceDefinition.officialNotes.scientificPaper": "Издаване на служебни бележки за депозиран научен ръкопис",
    "m.serviceDefinition.officialNotes.dissertationThesis":
      "Издаване на служебни бележки за защитен дисертационен труд",
    "m.serviceDefinition.officialNotes.academicPosition": "Издаване на служебни бележки за заета академична длъжност",
    "m.serviceDefinition.inquiry.impactFactor": "Изготвяне на справки за импакт фактор на научни периодични издания",
    "m.serviceDefinition.inquiry.publicationCitings": "Изготвяне на справки за цитирания на публикации",
    "m.serviceDefinition.analyticProducts": "Изготвяне на аналитични информационни продукти",
    "m.serviceDefinition.bibliographicReferences.nacidDbs":
      "Изготвяне на библиографска справка чрез търсене в базите данни и електронните каталози на НАЦИД",
    "m.serviceDefinition.bibliographicReferences.foreignDbs":
      "Изготвяне на библиографска справка чрез достъп до чужди бази данни и други интернет ресурси",
    "m.serviceDefinition.documentDelivery.libraries":
      "Доставка на документи в печатна и електронна форма от библиотеки в страната и чужбина",
    "m.serviceDefinition.documentDelivery.nacid": "Предоставяне на копия на документи от фондове на НАЦИД",
    "m.serviceDefinition.arUniEntryRequest": "Подаване на данни по чл.19, ал.2",
    "m.middleName.required.if.exists": "Попълнете полето за презиме, ако лицето има презиме !",
    "m.empty.contactAddress.default": "Не е въведен адрес за контакт по подразбиране",
    "m.empty.receiveResult.way.default": "Не е въведен начин за получаване на резултат по подразбиране",
    "m.empty.receiverAddress.default": "Не е въведен адрес на получател по подразбиране",
    "m.user.update.success": "Данните на потребителя са успешно редактирани",
    "m.myApplications.description":
      "Пълен списък със заявени в НАЦИД електронни услуги през този потребителски профил, с актуален статус и възможност за редакция и подаване на тези от тях, които не са подадени.",
    "m.myPayments.description": "История на дължимите такси и извършени плащания, с възможност за онлайн плащане.",
    "m.myCorrespondence.description": "Електронни съобщения, изпратени от НАЦИД през портала за електронни услуги.",
    "m.arUniEntryRequest.description":
      "Подаване на данни към регистър Академично признаване с решения на висши училища за признати дипломи в случаите по чл. 6, т. 1 с цел обучение за повишаване на квалификацията, както и във всички случаи на отказ за признаване.",
    "m.arUniEntryRequest.list.description":
      "Списък с подадените през този потребителски профил данни по чл.19, ал.2, с възможност за редакция и публикуване в регистъра на тези, които са в статус Чернова.",
    "m.search.error": "Грешка при търсенето. Моля опитайте по-късно.",

    "t.module.keycloak": "Keycloak сървър",
    "t.module.registers": 'Модул "Регистри"',
    "t.module.services": 'Модул "Услуги"',
    "t.module.portal": 'Модул "Портал"',
    "t.module.core": 'Модул "Основен"',

    "l.parentGroup": "Родителска група",
    "t.hierarchy.details": "Йерархия на групите",
    "t.inherited.roles": "Наследени роли",
    "m.portalLogin": "Влизане в портала",

    "t.qualCompare.mainH.level": "Ниво от Националната Квалификационна Рамка на ",
    "t.qualCompare.mainH.level.short": "Ниво - НКР",
    "t.qualCompare.mainH.subLevel": "Степени на Висшето образование от Националната Квалификационна Рамка на ",
    "t.qualCompare.mainH.subLevel.short": "Степени - НКР",
    "t.qualCompare.sideH.levelEQF": "Ниво според Европейската Квалификационна Рамка",
    "t.qualCompare.sideH.levelEQF.short": "Ниво - ЕКР",
    "t.qualCompare.sideH.levelBC": "Цикъл според Болонската конвенция",
    "t.qualCompare.sideH.levelBC.short": "Болонска конвенция",
    "t.qualCompare.sideH.levelBG": "Ниво според Българската Квалификационна Рамка",
    "t.qualCompare.sideH.levelBG.short": "Ниво - БКР",
    "t.qualCompare.subH.level": "Ниво",
    "t.qualCompare.subH.degree": "Степен",
    "t.qualCompare.subH.levelNative": "Ниво на оригинален език",
    "t.qualCompare.subH.degreeNative": "Степен на оригинален език",
    "t.qualCompare.subH.credits": "Кредити",
    "t.qualCompare.subH.duration": "Продължителност",
    "t.qualCompare.mapTitle": "Карта на държавите",

    ...validationKeysBG.translation,
  },
});

export default messagesBg;
